// components
import { Form, Input, Card, Alert } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useVoidCRTransactionPage } from "containers/VoidCRTransaction/useVoidCRTransactionPage";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import moment from "moment";
import { DateTimeFormats } from "constants/global";

import styles from "containers/VoidCRTransaction/VoidCRTransactionPage.module.css";

// constants
import { VOID_CR_TRANSACTION as Constants, PageTitles } from "constants/global";

const VoidCRTransactionPage = () => {
	const { proceedToGetCRTransaction, proceedToVoidCRTransaction, loading, form, posTransactionId, transactionDetails, handlePosTransactionId, hasVouchers } =
		useVoidCRTransactionPage();

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title={Constants.PAGE_HEADER} subTitle={Constants.PAGE_SUBHEADER} />
			<div className={styles?.root}>
				<Head>{PageTitles.VOID_CR_TRANSACTION}</Head>
				<Form className={styles?.form} form={form} requiredMark={false} layout="horizontal">
					<Form.Item
						label={<Label requiredMark={true} label={Constants.POS_TRANSACTION_ID_LABEL} classes={{ label: styles?.basic_input_label }} />}
						name={Constants.POS_TRANSACTION_ID_LABEL}
					>
						<Input className={styles?.input_field} placeholder={Constants.POS_TRANSACTION_ID_PLACEHOLDER} value={posTransactionId} onChange={(e) => handlePosTransactionId(e)} />
					</Form.Item>
				</Form>
				<div className={styles.buttonWrapper}>
					<Button label={Constants.GET_BUTTON_LABEL} type={posTransactionId ? "activeLong" : "disabledLong"} onClick={proceedToGetCRTransaction} />
				</div>
				{transactionDetails && transactionDetails.pos_transaction_id && (
					<div>
						<Card title="Transaction Header" bordered={true} style={{ maxWidth: 560 }}>
							<table className={styles.transactionHeader}>
								<tr>
									<th>Pos Transaction Id</th>
									<td>{transactionDetails.pos_transaction_id}</td>
								</tr>
								{transactionDetails.receipt_no && (
									<tr>
										<th>Receipt No</th>
										<td>{transactionDetails.receipt_no}</td>
									</tr>
								)}
								<tr>
									<th>Date</th>
									<td>{moment(transactionDetails.date?.created_on)?.format(DateTimeFormats.USE_SECONDS)}</td>
								</tr>
								<tr>
									<th>Is Voided</th>
									<td>{transactionDetails.is_voided ? "Yes" : "No"}</td>
								</tr>
							</table>
						</Card>
						<br />
						<Card title="Transaction Payments" bordered={true} style={{ maxWidth: 560 }}>
							<table className={styles.transactionPayments}>
								<tr>
									<th>Type</th>
									<th>Amount</th>
								</tr>
								{transactionDetails &&
									transactionDetails.payments &&
									transactionDetails.payments.map((payment: any, index: any) => (
										<tr key={index}>
											<td>{payment.type}</td>
											<td>{payment.amount.toLocaleString("en-SG", { style: "currency", currency: "SGD" })}</td>
										</tr>
									))}
							</table>
						</Card>
						{transactionDetails.is_voided && <Alert message="Warning" description="Transaction is already voided." type="warning" showIcon className={styles.alert} />}
						{hasVouchers && <Alert message="Warning" description="Transaction paid with vouchers." type="warning" showIcon className={styles.alert} />}
						<div className={styles.buttonWrapper}>
							<Button
								label={Constants.VOID_BUTTON_LABEL}
								type={!hasVouchers ? (transactionDetails.is_voided ? "disabledLong" : "activeLong") : "disabledLong"}
								onClick={proceedToVoidCRTransaction}
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default VoidCRTransactionPage;
